import Scenarios from '../../AUComps/Scenarios';
import BundleJP from './JP';
import BundleNA from './NA';
import BundleNA2 from './NA2';
import TAndC from './TAndC';
import { useGlobal } from '@/utils/useGlobal';

export default function DP3Bundle() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    return (
        <>
            {locale === 'jp' && <BundleJP />}
            {['br', 'mx'].includes(locale) && <BundleNA />}
            {['us', 'ca'].includes(locale) && <BundleNA2 />}
            {locale === 'jp' && <TAndC />}
            {locale === 'au' && <Scenarios />}
        </>
    );
}
